
import WineList from './components/WineList';
import './App.css';

export default function App() {
  return (
    <main>
      <h1>Wine List</h1>
      <WineList/>
    </main>
  );
}

